module.exports = __webpack_public_path__ + "img/全钢实验台.cf04a3b2.jpg";